module.exports = __webpack_public_path__ + "static/media/_L3-Sass.b78eeaa1.svg";